export default __webpack_public_path__ + "static/media/Left line.3de1f01c.svg";